//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TransferenciaDefinitiva from './TransferenciaDefinitiva';
import TooltipAjuda from '../../../../../shared-components/TooltipAjuda';

export default {
  name: 'TransferenciaPosseDefinitivaPasso1',
  components: {
    TooltipAjuda,
  },
  data() {
    return {
      resources: this.$api.transferenciaPosseDefinitiva(this.$resource),

      passo: 1,
      rules: {
        required: value => !!value || this.$t('message.campo_obrigatorio'),
      },
      transferencia: new TransferenciaDefinitiva(),
      listaDe: [],
      listaPara: [],
      buscaListaDe: null,
      buscaListaPara: null,
      vendedoresDe: [],
      vendedoresPara: [],
    };
  },
  watch: {
    buscaListaDe(val) {
      if (this.transferencia.funcionarioDe && this.transferencia.funcionarioDe.nome === val) return;
      if (this.timeoutDe) {
        window.clearTimeout(this.timeoutDe);
      }
      this.timeoutDe = window.setTimeout(() => {
        if (val) this.buscarFuncionarioDe(val);
      }, 500);
    },
    buscaListaPara(val) {
      if (this.transferencia.funcionarioPara
        && this.transferencia.funcionarioPara.nome === val) return;
      if (this.timeoutDe) {
        window.clearTimeout(this.timeoutDe);
      }
      this.timeoutDe = window.setTimeout(() => {
        if (val) this.buscarFuncionarioPara(val);
      }, 500);
    },
  },
  methods: {
    cancelar() {
      this.$emit('TRANSFERENCIA_DEFINITIVA_CANCELAR');
    },
    proximoPasso() {
      if (this.$refs.form.validate()) {
        if (this.transferencia.cenario === 3) {
          // Filtrar os vendedores que serão transferidos
          const selecionados = this.vendedoresPara.filter(p => p.origem === 'de');
          if (this.vendedoresDe.length) {
            this.$toast.create(this.$t('message.selecione_vendedores_transferir'), 'snack', 3E3);
            return;
          }
          this.transferencia.usuarios = selecionados;
        }
        this.$emit('TRANSFERENCIA_DEFINITIVA_CONTINUAR', this.passo + 1, this.transferencia);
      }
    },
    buscarFuncionarioDe(busca = null) {
      if (typeof busca !== 'string') {
        busca = null;
      }
      // Cenario 1 e 2:
      const param = {
        filtro: busca,
        rateio: true,
        vendedor: true,
        estruturaFolha: true,
        tamanhoPagina: 20,
      };

      if (this.transferencia.cenario === 4) {
        param.vendedor = false;
        param.estruturaFolha = false;
      } else if (this.transferencia.cenario === 3) {
        param.estruturaPai = true;
        param.estruturaFolha = false;
      }

      this.resources.listarFuncionarios(param).then((response) => {
        this.listaDe = Object.assign([], response.data.resposta);
      }, (err) => {
        this.$error(this, err);
      });
    },
    buscarFuncionarioPara(busca = null) {
      if (this.transferencia.funcionarioDe) {
        if (typeof busca !== 'string') {
          busca = null;
        }

        const param = {
          filtro: busca,
          rateio: true,
          mesmoCanal: true,
          mesmaUnidade: true,
          idNotIn: this.transferencia.funcionarioDe.id,
          tamanhoPagina: 20,
        };

        if (this.transferencia.cenario === 1) {
          param.estruturaPai = true;
          param.mesmaEstruturaPai = true;
        } else if (this.transferencia.cenario === 2) {
          param.estruturaFolha = true;
          param.vendedor = true;
        } else if (this.transferencia.cenario === 4) {
          param.vendedor = false;
          param.mesmaEstrutura = true;
        } else if (this.transferencia.cenario === 3) {
          param.estruturaPai = true;
          param.vendedor = true;
        }

        this.resources.listarFuncionarios(param).then((response) => {
          this.listaPara = Object.assign([], response.data.resposta);
        }, (err) => {
          this.$error(this, err);
        });
      }
    },
    selecionaUsuarioDe(superior) {
      if (this.transferencia.cenario === 3 && superior) {
        const param = {
          vendedor: true,
          idSuperior: superior.id,
          tamanhoPagina: 50,
        };
        this.resources.listarFuncionarios(param).then((response) => {
          this.vendedoresDe = Object.assign([], response.data.resposta);
        }, (err) => {
          this.$error(this, err);
        });
      }
    },
    selecionaUsuarioPara(superior) {
      if (this.transferencia.cenario === 3 && superior) {
        const param = {
          vendedor: true,
          idSuperior: superior.id,
          tamanhoPagina: 50,
        };
        this.resources.listarFuncionarios(param).then((response) => {
          this.vendedoresPara = Object.assign([], response.data.resposta);
        }, (err) => {
          this.$error(this, err);
        });
      }
    },
    labelSelecaoUsuarioDe() {
      if (this.transferencia.cenario === 1 || this.transferencia.cenario === 2) {
        return this.$tc('label.de_vendedor', 1);
      } else if (this.transferencia.cenario === 3) {
        return this.$tc('label.de_gestor', 1);
      } else if (this.transferencia.cenario === 4) {
        return this.$tc('label.de_usuario_distribui_verba', 1);
      }
      return this.$tc('label.de', 1);
    },
    labelSelecaoUsuarioPara() {
      if (this.transferencia.cenario === 1) {
        return this.$tc('label.para_novo_superior_imediato', 1);
      } else if (this.transferencia.cenario === 2) {
        return this.$tc('label.para_vendedor', 1);
      } else if (this.transferencia.cenario === 3) {
        return this.$tc('label.para_gestor', 1);
      } else if (this.transferencia.cenario === 4) {
        return this.$tc('label.para_usuario_distribui_verba', 1);
      }
      return this.$tc('label.para', 1);
    },
    limparPara(superior) {
      this.transferencia.funcionarioPara = null;
      this.listaPara = [];
      this.selecionaUsuarioDe(superior);
    },
    limparSelecaoUsuario() {
      this.transferencia.funcionarioDe = null;
      this.listaDe = [];
      this.transferencia.funcionarioPara = null;
      this.listaPara = [];
      this.vendedoresDe = [];
      this.vendedoresPara = [];
    },
    enviarDePara() {
      const selecionados = [];
      for (let i = this.vendedoresDe.length - 1; i >= 0; i -= 1) {
        const v = this.vendedoresDe[i];
        v.origem = 'de';
        selecionados.push(v);
      }
      if (selecionados.length) {
        this.vendedoresDe = [];
        this.vendedoresPara = this.vendedoresPara.concat(selecionados);
      }
    },
    enviarParaDe() {
      const selecionados = this.vendedoresPara.filter(v => v.origem === 'de');
      const para = this.vendedoresPara.filter(v => v.origem !== 'de');
      if (selecionados.length) {
        this.vendedoresDe = this.vendedoresDe.concat(selecionados);
        this.vendedoresPara = para;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/transferencia-posse/definitiva/TransferenciaPosseDefinitivaPasso1.vue?vue&type=script&lang=js&